import React, { useContext } from "react";
import { ScratchpadContext } from "contexts/ScratchpadProvider";
import ScratchpadModal from "components/scratchpad/ScratchpadModal";
const Scratchpad = () => {
  const { isScratchpadVisible } = useContext(ScratchpadContext);
  if (!isScratchpadVisible) return null;
  return /* @__PURE__ */ React.createElement(ScratchpadModal, null);
};
export default Scratchpad;
